import { constants } from '@eti/utils';

const { brands } = constants;
const tripStackPartners = ['ts_wl_vi', 'ts_wl_vi_mix'];

const getPartner = (partner: string) =>
  tripStackPartners.includes(partner) ? brands.TRIPSTACK : partner;

type GetBrandCodeParams = {
  brand?: { code: string };
  partner?: string;
};

const getBrandCode = (
  { brand = { code: '' }, partner = '' }: GetBrandCodeParams = {},
  shouldUsePartnerTheme?: boolean,
) => {
  if (shouldUsePartnerTheme) {
    const lowerCasedPartner = getPartner(partner.toLowerCase());
    const isPartner = Object.values(brands).some((brandCode) => brandCode === lowerCasedPartner);

    return isPartner ? lowerCasedPartner : brand.code.toLowerCase();
  }

  return brand.code.toLowerCase();
};

export default getBrandCode;
